export default __webpack_public_path__ + "static/media/cancel.019f90ad.svg";